import { combineReducers } from "redux";
import { reducers as auth } from "./auth";
import { reducers as schedule } from "./schedule";
import { reducers as log } from "./log";
import { reducers as zone } from "./zone";
import { reducers as admin } from "./admin";

const rootReducer = combineReducers({
  auth,
  schedule,
  log,
  zone,
  admin,
});

export default rootReducer;
